import { GoalFilterDocument } from '@griply/types';
import {
  getGoalListControlDocument,
  getGoalListEntityUpdate,
  goalAndProjectFilterSections,
} from '@griply/utils';
import { useUpdateGoal } from 'features/goals';
import React, { useMemo } from 'react';
import { GoalListFilterButton } from 'shared/components/connected/goal-list-filter-button';
import { Goal } from 'shared/types/goal';

export type SubgoalsFilterButtonProps = {
  goal: Goal;
};

export const SubgoalsFilterButton: React.FC<SubgoalsFilterButtonProps> = ({
  goal,
}) => {
  const { submit: updateGoal } = useUpdateGoal();

  const filterDocument = useMemo(
    () =>
      getGoalListControlDocument({
        goalFilterDocument: goal.goalFilterDocument,
        goalSortingMode: goal.goalSortingMode,
      }),
    [goal.goalFilterDocument, goal.goalSortingMode],
  );

  const persist = (next: Partial<GoalFilterDocument>) => {
    const update = getGoalListEntityUpdate({
      ...filterDocument,
      ...next,
    });
    updateGoal({ id: goal.id, ...update });
  };

  const handleReset = () => persist({ filters: null });

  return (
    <GoalListFilterButton
      filterDocument={filterDocument}
      hideLifeArea
      filterSections={goalAndProjectFilterSections}
      onUpdate={persist}
      onReset={handleReset}
    />
  );
};
